exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-455766aa] svg{vertical-align:unset}", ""]);

// exports
